var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMg = function SvgMg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff3319",
    d: "M213.33 0H640v240H213.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cc28",
    d: "M213.33 240H640v240H213.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h213.33v480H0z"
  }))));
};
export default __webpack_public_path__ + "assets/bc0aaf02fd22e03fe43c61b77d22f155.svg";
export { SvgMg as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/mg.svg